import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';

import { Badge } from './Badge';
import {
  STATUS_BADGE_ICON_SLOT,
  STATUS_BADGE_SIZE,
  STATUS_ICON,
  STATUS_TONE,
  STATUS_TONE_FALLBACK,
  STATUS_TONE_INTERACTIVE,
  STATUS_TONE_INTERACTIVE_FALLBACK,
} from './statusBadgeTheme';

const SIZE_CLASS = {
  default: STATUS_BADGE_SIZE,
  sm: STATUS_BADGE_SIZE,
};

const StatusBadge = ({ status, label, size = 'default', className, onClick }) => {
  const Icon = STATUS_ICON[status];
  const toneClass = STATUS_TONE[status] ?? STATUS_TONE_FALLBACK;
  const clickable = typeof onClick === 'function';
  const interactiveClass = clickable
    ? (STATUS_TONE_INTERACTIVE[status] ?? STATUS_TONE_INTERACTIVE_FALLBACK)
    : undefined;

  return (
    <Badge
      variant="secondary"
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      className={cn(
        SIZE_CLASS[size] ?? SIZE_CLASS.default,
        STATUS_BADGE_ICON_SLOT,
        toneClass,
        clickable && 'cursor-pointer transition-colors',
        interactiveClass,
        className,
      )}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick(event);
        }
      } : undefined}
    >
      {Icon ? <Icon aria-hidden /> : null}
      {label}
    </Badge>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string,
  label: PropTypes.node,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export { StatusBadge };
